import { api } from '..';
import parseResponse from './parseResponse';
export const getProjectAccounting = projectId => parseResponse(api.billing.getProjectAccounting(projectId));
export const getProjectPriceChanges = projectId => parseResponse(api.billing.getProjectPriceChanges(projectId));
export const getAdjustments = projectId => parseResponse(api.billing.getAdjustments(projectId));
export const createAdjustment = (projectId, data) => parseResponse(api.billing.createAdjustment(projectId, data));
export const getContractTerms = teamId => api.billing.getContractTerms(teamId).then(response => Promise.resolve(response.data));
export const createNewContractTerms = async (teamId, data) => {
  return api.billing.createContractTerms(teamId, data).then(({
    data
  }) => Promise.resolve(data));
};
export const updateContractTerms = (teamId, contractTermsId, data) => {
  return api.billing.updateContractTerms(teamId, contractTermsId, data).then(({
    data
  }) => Promise.resolve(data));
};
export const deleteContractTerms = (teamId, contractTermsId) => {
  return api.billing.deleteContractTerms(teamId, contractTermsId).then(() => Promise.resolve());
};